export const API_URL = process.env.REACT_APP_API_URL
// export const API_URL = "https://api.postmarket.am/"

// export const API_URL =process.env.NODE_ENV === "production"?
//  "https://admin.postmarket.am":"https://admin.postmarket.am";

